import { render } from "./BcaCyberView.vue?vue&type=template&id=6ec28280"
import script from "./BcaCyberView.vue?vue&type=script&lang=js"
export * from "./BcaCyberView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__